import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    margin: '25px 0px 50px 0px',
  },
  text: {
    textAlign: 'center',
    color:Colors.Blue,
    fontWeight: 'bold !important',
  },
  textLink: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  contactEmail: {
    background: Colors.White,
    marginTop: 30,
    padding: 16,
    fontWeight:'bold',
    color:Colors.Blue,
    paddingBottom: 25,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'end',
    padding: '16px 0',
  },
  button: {
    maxWidth: 240,
  },
  textArea: {
    width: '100%',
    minHeight: '200px',
    padding: 8,
    resize: 'none',
  },
}));

export default useStyles;